module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Mobilyze_image_1.5ed60848.jpg";